import UsersSessionsNew from './UsersSessionsNew'

export default UsersSessionsNew
